// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"82c12db6","453":"8639371c","455":"3d153683","977":"ce2a4fb2"}[chunkId] + ".chunk.js";
};